import vue from "../main";

export default function() {
  return [
    {
      value: 0,
      text: vue.$t("$staticData.delegationEmailTypes.revertDefaultValue")
    },
    { value: 1, text: vue.$t("$staticData.delegationEmailTypes.disable") },
    { value: 2, text: vue.$t("$staticData.delegationEmailTypes.notifyOnly") },
    {
      value: 3,
      text: vue.$t("$staticData.delegationEmailTypes.notifyWithNoLoginActionLinks")
    }
  ];
}
